import type { SYSState } from "../../../../../../../_ovlclient/src"
import { SYSScreen, html, ovl } from "../../../../../../../_ovlclient/src"
import { D, T } from "../../../../../../../_ovlclient/src/textapi"

import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import { FeatureInfo } from "../../../../../../../_ovlclient/src/global/globalapi"
import {
  FieldIsValid,
  FieldVal,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import { FormGet } from "../../../../../../../_ovlclient/src/library/forms/formapi"
import {
  ProcessEnd,
  ProcessIsRunning,
  ProcessStart,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { ScreenCurrent } from "../../../../../../../_ovlclient/src/library/screenapi"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"
import {
  TableFormEditRow,
  TableGet,
  TableRefresh,
} from "../../../../../../../_ovlclient/src/library/table/tableapi"
import type { Offering } from "../../../features/qutoffering/offering/tabledef"

export const OfferingMainRefresh = async (
  state: SYSState,

  docEntry?: number,
  screen?: SYSScreen,
  justRefreshColumns?: boolean
) => {
  let filter = { LinkedInCalc: false }
  let serverFilter = {}
  var isOfferAdmin = !!FeatureInfo("QUTOfferingToolAdmin")
  let cardCodeValid = true
  let cardCode = state.ovl.user.cardCode
  const isAdminScreen =
    screen === "QUTOfferingAdmin" || screen === "QUTOfferingAdminCut"
  if (isAdminScreen) {
    let bpFilterForm = FormGet("QUTBPFilter")
    if (bpFilterForm.formState) {
      let cardCodeField = bpFilterForm.fields["CardCode"]
      cardCodeValid = FieldIsValid(cardCodeField)
      cardCode = FieldVal(cardCodeField)
    }
  }
  if (cardCode && FeatureInfo("QUTOfferingToolAdmin")) {
    filter["CardCode"] = cardCode
  }

  let offerMainType = state.app.features.QUTOffering.offerMainType
  filter["U_ITF_PRT_OfferMainType"] = offerMainType

  if (docEntry) {
    serverFilter["DocEntry"] = docEntry
  }

  let staticFilter = filter
  if (cardCodeValid) {
    staticFilter["U_ITF_PRT_OfferType"] = "Target"
    await TableRefresh("QUTOffering", {
      serverFilter,
      forcedFilters: { staticFilter },
      resetStrategy: { Columns: true },
      preferCache: justRefreshColumns,
      suppressBusySnack: justRefreshColumns,
    })
    if (isOfferAdmin && screen !== "QUTOffering" && offerMainType === "CAD") {
      staticFilter["U_ITF_PRT_OfferType"] = "Actual"
      await TableRefresh("QUTOfferingActual", {
        forcedFilters: { staticFilter },
        preferCache: true,
        resetStrategy: { Columns: true },
        suppressBusySnack: true,
      })
    }
  }
  // get deliverweeks relevant for offering (adjusted by an offset weeks from settings tab)
  let res = await Data("offering/offeringdeliveryweeks", offerMainType)

  let notRelevant = {
    MidDate: null,
    WeekNr: T("QUTOfferingOfferingProvisionallyOffer"),
    Range: "",
  }
  res.data.data["null"] = notRelevant
  state.app.features.QUTOffering.lookups.WeekAndDate = res.data
  state.app.features.QUTOffering.lookups.WeekAndDate.sortFn = (a, b) => {
    if (a.MidDate === null) {
      return -1
    }
    return 0
  }

  if (screen === "QUTOfferingAdmin") {
    // also refresh calc
    let res = await Data("offering/offeringsalescalc", { cardCode })
    state.app.features.QUTOffering.adminSalesCalcResult = res.data.data
  }

  if (!justRefreshColumns) {
    ReShowOfferingInProgressSnack()
  }
}
export const ReShowOfferingInProgressSnack = () => {
  // if a offering is in process then display snack
  let state = ovl.getState()
  let actions = ovl.getActions()
  let docEntry = GetUnfinishedDocEntry()

  if (!docEntry && state.app.features.QUTOffering.detailsChanged) {
    docEntry =
      state.app.global.QUT.tables.QUTOffering.data[
        state.app.features.QUTOffering.selectedOfferKey
      ]["DocEntry"]
  }
  if (
    docEntry &&
    state.app.features.QUTOffering.lastProgressStatus === undefined
  ) {
    actions.app.features.QUTOffering.actions.ShowOfferingProgress({
      docEntry,
      clearError: false,
    })
    actions.app.screens
  }
}

export const GetDeliveryTimeHint = (
  state: SYSState,
  midDate: string,
  isEdit: boolean = false
) => {
  let deliveryTimeHint = T("QUTOfferingOfferingProvisionallyOffer")
  if (isEdit) {
    deliveryTimeHint = ""
  }

  if (midDate) {
    let weekAndDateData = state.app.global.GEN.lookups.weekAndDate.data

    if (weekAndDateData[midDate]) {
      let deliveryTimeHints =
        `KW ${weekAndDateData[midDate]["WeekNr"]} (${weekAndDateData[midDate]["Range"]})`.split(
          "/"
        )
      // prettier-ignore
      //@ts-ignore
      deliveryTimeHint = html`<b>${deliveryTimeHints[0]}</b>/${deliveryTimeHints[1]}`
    } else {
      deliveryTimeHint = `~${D(midDate)}`
    }
  }
  return { res: deliveryTimeHint }
}

export const EditLocked = () => {
  let state = ovl.getState()
  let selectedKey = state.app.features.QUTOffering.selectedOfferKey
  let notEditable =
    selectedKey &&
    !FeatureInfo("QUTOfferingToolAdmin") &&
    ScreenCurrent() === "QUTOfferingDetails" &&
    (<Offering>state.app.global.QUT.tables.QUTOffering.data[selectedKey])
      .U_ITF_PRT_OfferStatus === <OfferingStatus>"Accepted"

  return (
    notEditable ||
    ProcessIsRunning("GENNewOfferUpload") ||
    ProcessIsRunning("OfferingStatus") ||
    ProcessIsRunning("QUTOfferingRecalcStatus")
  )
}

export const GetUnfinishedDocEntry = (): number => {
  let baseTableKeys
  let table = TableGet("QUTOffering")
  let cardCode = table.staticFilterGet().CardCode
  // default is all visible keys
  if (cardCode === undefined) {
    baseTableKeys = table.getKeys()
  } else {
    baseTableKeys = table.getKeys({ byFilter: { CardCode: cardCode } })
  }

  let keys = baseTableKeys.filter((k) => {
    let status: OfferingStatus = table.rows[k]["U_ITF_PRT_OfferStatus"]
    let error = table.rows[k]["U_ITF_PRT_OfferError"]
    return !error && status !== "Ready" && status !== "Accepted"
  })

  if (keys.length > 0) {
    return table.rows[keys[0]]["DocEntry"]
  }
}

export const OpenTableUploadEdit = async () => {
  let t = TableGet("QUTOfferingAdminUpload")
  let resumeDocEntry =
    ovl.getState().app.features.QUTOffering.adminResumeDocEntry
  let localData: any = {}
  if (t.getKeys({ byKeys: "All" }).length === 0 || resumeDocEntry) {
    // table needs refresh
    localData.OfferType = "Actual"
    localData.FileType = "bvx"

    // if its a resume init the upluadform with the corresponding information
    if (resumeDocEntry) {
      let sourceTable = TableGet("QUTOffering", { byIdValue: resumeDocEntry })
      let row = sourceTable.rows[sourceTable.getKeys()[0]]
      localData.CntctCode = row.CntctCode
      localData.CardCode = row.CardCode
      localData.OfferType = row.U_ITF_PRT_OfferType
    }

    await TableRefresh("QUTOfferingAdminUpload", { localData: [localData] })
  }
  await TableFormEditRow("QUTOfferingAdminUpload")
}

export const SelectOfferFile = async (
  file: File,
  fileFormData: FormData,
  cadUserField?: string,
  cadAttr?: string,
  cadVal?: string,
  offerType?: string,
  cardCode?: string,
  cntctCode?: string,
  desc?: string
) => {
  if (!file && !fileFormData) {
    return
  }
  ovl.getState().app.features.QUTOffering.lastProgressStatus = undefined
  let offeringToolState = ovl.getState().app.features.QUTOffering
  let formData
  if (!fileFormData) {
    formData = new FormData()
  } else {
    formData = fileFormData
  }
  if (!fileFormData) {
    formData.append("file", file)
    formData.append("cat", "OfferingToolNewOffer")
  } else {
    formData.set("cat", "OfferingToolNewOffer")
  }

  let id1
  let id2
  if (cadUserField) {
    id1 = cadUserField
  } else if (cadAttr) {
    id1 = cadAttr
  } else if (ovl.getState().app.global.GEN.user.offeringCadUserField) {
    id1 = ovl.getState().app.global.GEN.user.offeringCadUserField
  } else if (ovl.getState().app.global.GEN.user.offeringCadAttr) {
    id1 = ovl.getState().app.global.GEN.user.offeringCadAttr
  }
  if (id1) {
    formData.set("id1", id1)
  }
  if (cadVal) {
    id2 = cadVal
  } else if (ovl.getState().app.global.GEN.user.offeringCadVal) {
    id2 = ovl.getState().app.global.GEN.user.offeringCadVal
  }
  if (id2) {
    formData.set("id2", id2)
  }
  let data: Offering =
    ovl.getState().app.global.QUT.tables.QUTOffering.data[
      offeringToolState.selectedOfferKey
    ]

  let existingEntry
  if (offeringToolState.adminResumeDocEntry !== undefined) {
    formData.append("id3", offeringToolState.adminResumeDocEntry)
    existingEntry = offeringToolState.adminResumeDocEntry
  } else if (
    data &&
    (ScreenCurrent() === "QUTOfferingDetails" ||
      data.U_ITF_PRT_OfferStatus === "Init")
  ) {
    // its an existing one, so add docEntry
    formData.append("id3", data.DocEntry.toString())
    existingEntry = data.DocEntry.toString()
  }

  formData.append("uploadDefId", "cad")

  let id4
  if (offerType) {
    id4 = offerType
  }
  if (id4) {
    formData.append("id4", id4)
  }

  if (cntctCode) {
    formData.append("cntctCode", cntctCode)
  }

  if (cardCode) {
    formData.append("cardCode", cardCode)
  }

  if (desc !== undefined) {
    formData.append("desc", desc)
  }

  // offeringToolState.uploadInProgress = true
  ProcessStart("GENNewOfferUpload")
  try {
    let res = await Data("assets/upload", formData, { isFormData: true })
    offeringToolState.adminResumeDocEntry = undefined
    // if (!existingEntry) {
    //   await OfferingMainRefresh(
    //     ovl.getState(),
    //     ovl.getActions(),
    //     undefined,
    //     ScreenCurrent()
    //   )
    // } else {
    //   // ovl.getActions().app.features.QUTOffering.actions.ShowOfferingProgress({
    //   //   docEntry: res.data.docEntry,
    //   //   clearError: false,

    //   //})
    await OfferingMainRefresh(
      ovl.getState(),

      existingEntry,
      ScreenCurrent()
    )
    //}
  } finally {
    ProcessEnd("GENNewOfferUpload")
  }
}

export const BrowseOfferFile = () => {
  if (!ovl.getState().app.global.GEN.user.offeringCadVal) {
    SnackAdd(T("QUTOfferingOfferingDefineAttributeFirst"), "Warning", 6000)
    return
  }
  let browseFileEl = <HTMLInputElement>(
    document.getElementById("offering-newfile")
  )
  let acceptExtensions = ".3d"
  if (FeatureInfo("QUTOfferingToolAdmin")) {
    acceptExtensions += ",.bvx"
  }
  browseFileEl.setAttribute("accept", acceptExtensions)

  browseFileEl.value = ""
  browseFileEl.click()
}

export type OfferingStatus =
  | "Init"
  | "Downloaded"
  | "SubmittedToCadwork"
  | "PrepareCalculating"
  | "Calculating"
  | "CreateOfferPos"
  | "Ready"
  | "Accepted"
  | "Canceled"
